<template>
  <EntityAssignmentMenu
    v-if="centralSystemId"
    :entity-id="centralSystemId"
    :on-assign="handleAssign"
    :on-unassign="handleUnassign"
    :on-fetch-owners="handleFetchOwners"
    :assign-permission-id="centralSystemAccessManagementPermissions.ASSIGN"
    :unassign-permission-id="centralSystemAccessManagementPermissions.UNASSIGN"
  />
</template>

<script lang="ts" setup>
import {
  assignCentralSystem,
  centralSystemAccessManagementPermissions,
  getCentralSystemOwners,
  unassignCentralSystem
} from '@infuse/api/e-connector/central-system';
import { CentralSystem } from '@infuse/e-connector/central-system/domain';
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useEntityAccessAssignment } from './composables/useEntityAccessAssignment';
import EntityAssignmentMenu from './EntityAssignmentMenu.vue';

interface Props {
  centralSystem?: CentralSystem;
}

const props = withDefaults(defineProps<Props>(), {
  centralSystem: undefined
});

const route = useRoute();

const centralSystemId = computed((): string | undefined => {
  return props.centralSystem?.id?.toString() ?? route.params.id?.toString();
});

const { handleFetchOwners, handleAssign, handleUnassign } = useEntityAccessAssignment(
  getCentralSystemOwners,
  assignCentralSystem,
  unassignCentralSystem
);
</script>
